/**
 * Localizes the auth error messages returned by the API.
 *
 * The backend replies in English (e.g. "Invalid username or password."). The
 * sign-in / sign-up screens run this over the server text so the user sees the
 * message in the language they picked. Anything we don't recognise is passed
 * through unchanged rather than dropped.
 */

const KEYS = [
  { match: /invalid username or password|invalid credentials/i, key: 'srvInvalidCredentials' },
  { match: /user not found/i, key: 'srvUserNotFound' },
  { match: /username is already taken|username already exists/i, key: 'srvUsernameTaken' },
  { match: /email address is already registered|email already exists/i, key: 'srvEmailTaken' },
  { match: /multiple accounts use this email/i, key: 'srvMultipleAccounts' },
  { match: /verification link has already been used/i, key: 'srvVerificationUsed' },
  { match: /failed to create verification token/i, key: 'srvVerificationTokenFailed' },
  { match: /account (is )?(deactivated|disabled|inactive)/i, key: 'srvAccountDisabled' },
  { match: /registration failed/i, key: 'errRegistrationFailed' },
  { match: /login failed/i, key: 'loginFailed' },
  { match: /^(server error|database error)$/i, key: 'srvServerError' },
];

/**
 * @param {string} message — raw error text from the API
 * @param {object} auth — the active locale's `t.auth` bundle
 * @param {string} [fallbackKey] — auth key to use when message is empty
 */
export function localizeAuthError(message, auth, fallbackKey) {
  const raw = String(message || '').trim();
  if (!raw) return fallbackKey ? auth[fallbackKey] : '';

  for (const { match, key } of KEYS) {
    if (match.test(raw) && auth[key]) return auth[key];
  }
  return raw;
}
